/*custom menu logic*/
/*function setCookie(key, value, expiry) {
    var expires = new Date();
    expires.setTime(expires.getTime() + (expiry * 24 * 60 * 60 * 1000));
    document.cookie = key + '=' + value  + ';path=/' + ';expires=' + expires.toUTCString();
}

function getCookie(key) {
    var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
    return keyValue ? keyValue[2] : null;
}

function eraseCookie(key) {
    var keyValue = getCookie(key);
    setCookie(key, keyValue, '-1');
}*/

$( document ).ready(function() {

$(".custom-sub-mega-menu").hover(function(e){
  e.preventDefault();
  $(".custom-sub-mega-menu").removeClass('selected');
  $(this).addClass("selected");
  clickedmenu = "#" + $(this).attr("data-menu-id");
  //setCookie('navselected',clickedmenu,'30'); //(key,value,expiry in days)
  $("ul.link-list.custom").addClass("hide");
  $(clickedmenu).removeClass("hide"); 
});


/*if (typeof getCookie('navselected') === 'undefined'){
 //no cookie
} else {
  cookieExist = getCookie('navselected');
  dataAttr = cookieExist.substring(1, cookieExist.length);
  //console.log(dataAttr);
  $(".custom-top-menu-items li a[data-menu-id='" + dataAttr +"']").addClass('selected');
  $(cookieExist).removeClass("hide"); 
 //cookie
}*/

});

/*product names to lowercase then capitalize*/
var names = document.getElementsByClassName("prdt");
for (var i = 0; i < names.length; i++) {
  names[i].innerHTML = names[i].innerHTML.toLowerCase();
}


//logic for Mobile Menu tabs
/*ADA tabs*/
'use strict';

class TabsAutomatic {
  constructor(groupNode) {
    this.tablistNode = groupNode;

    this.tabs = [];

    this.firstTab = null;
    this.lastTab = null;

    this.tabs = Array.from(this.tablistNode.querySelectorAll('[role=tab]'));
    this.tabpanels = [];

    for (var i = 0; i < this.tabs.length; i += 1) {
      var tab = this.tabs[i];
      var tabpanel = document.getElementById(tab.getAttribute('aria-controls'));

      tab.tabIndex = -1;
      tab.setAttribute('aria-selected', 'false');
      this.tabpanels.push(tabpanel);

      tab.addEventListener('keydown', this.onKeydown.bind(this));
      tab.addEventListener('click', this.onClick.bind(this));

      if (!this.firstTab) {
        this.firstTab = tab;
      }
      this.lastTab = tab;
    }

    this.setSelectedTab(this.firstTab, false);
  }

  setSelectedTab(currentTab, setFocus) {
    if (typeof setFocus !== 'boolean') {
      setFocus = true;
    }
    for (var i = 0; i < this.tabs.length; i += 1) {
      var tab = this.tabs[i];
      if (currentTab === tab) {
        tab.setAttribute('aria-selected', 'true');
        tab.removeAttribute('tabindex');
        this.tabpanels[i].classList.remove('is-hidden');
        if (setFocus) {
          tab.focus();
        }
      } else {
        tab.setAttribute('aria-selected', 'false');
        tab.tabIndex = -1;
        this.tabpanels[i].classList.add('is-hidden');
      }
    }
  }

  setSelectedToPreviousTab(currentTab) {
    var index;

    if (currentTab === this.firstTab) {
      this.setSelectedTab(this.lastTab);
    } else {
      index = this.tabs.indexOf(currentTab);
      this.setSelectedTab(this.tabs[index - 1]);
    }
  }

  setSelectedToNextTab(currentTab) {
    var index;

    if (currentTab === this.lastTab) {
      this.setSelectedTab(this.firstTab);
    } else {
      index = this.tabs.indexOf(currentTab);
      this.setSelectedTab(this.tabs[index + 1]);
    }
  }

  /* EVENT HANDLERS */

  onKeydown(event) {
    var tgt = event.currentTarget,
      flag = false;

    switch (event.key) {
      case 'ArrowLeft':
        this.setSelectedToPreviousTab(tgt);
        flag = true;
        break;

      case 'ArrowRight':
        this.setSelectedToNextTab(tgt);
        flag = true;
        break;

      case 'Home':
        this.setSelectedTab(this.firstTab);
        flag = true;
        break;

      case 'End':
        this.setSelectedTab(this.lastTab);
        flag = true;
        break;

      default:
        break;
    }

    if (flag) {
      event.stopPropagation();
      event.preventDefault();
    }
  }

  onClick(event) {
    this.setSelectedTab(event.currentTarget);
  }
}

// Initialize tablist

window.addEventListener('load', function () {
  var tablists = document.querySelectorAll('[role=tablist].automatic');
  for (var i = 0; i < tablists.length; i++) {
    new TabsAutomatic(tablists[i]);
  }
});

// logic to only display 5 designers on mobile menu an see more if greater than 5
jQuery('.designer-wraper ul').each(function(i, obj) {
  const icons = jQuery(this).find('li');
   
  if (icons.length >= 4) {
  jQuery(this)
  .find('li:gt(4)')
  .hide()
  .end()
  .append(
    jQuery('<li>See more +</li>').click( function(){
      jQuery(this).siblings(':hidden').show().end().remove();
    })
   );
  }
  
});

// logic custom filter with theme
jQuery('.sort-by').change(function(){
  var data = jQuery(this).val();
 console.log(data); 
  jQuery('#SortBy')
    .val(data)
    .trigger('change');
  jQuery("#FacetFiltersForm").submit();
  console.log(jQuery('#SortBy').val(data));
});
jQuery('#CollectionProductCount').on('DOMSubtreeModified', function(){
  console.log('changed');
  jQuery('#CollectionProductCountCustom').text(jQuery('#CollectionProductCount').text());
 
  //logic filter hide promo and button if less than amount
    var itemcount = $('.site-box-product').length;
    if(itemcount < 8){
      $('.promo-collections').hide();
    } else{
      $('.promo-collections').show();
    }
    if(itemcount < 48){
     if ($('.pagination').length == 0){
      $('.jsonly.load-more').hide();
    }else{
     $('.jsonly.load-more').show();
    }
   } 
  
});


// logic scroll for designers/brands on desktop
if (jQuery('.heading-custom-padding').length) {
    var previousScroll = 0;
    var headerdes = jQuery(".heading-custom-padding");
    var headerdestopspacing = jQuery(".heading-custom-padding").offset().top;
    var topanchors = jQuery(".top-anchors");
    
    console.log(headerdestopspacing);
    jQuery(window).scroll(function() {
        var scroll = jQuery(window).scrollTop();
        var currentScroll =  jQuery(this).scrollTop();

        if (currentScroll > previousScroll){
           //scrolling down
              //headerdes.removeClass("fixed");
              //topanchors.removeClass("fixed");
            if (scroll >= headerdestopspacing) {
                //headerdes.addClass("fixed");
                //topanchors.addClass("fixed");
                headerdes.addClass("top");
                topanchors.addClass("top");            
            } else {
            }
         } else { 
           //scrolling up
          if (scroll >= headerdestopspacing) {
              //headerdes.addClass("fixed");
             // topanchors.addClass("fixed");
              headerdes.removeClass("top");
              topanchors.removeClass("top");            
          } else {
              //headerdes.removeClass("fixed");
              //topanchors.removeClass("fixed");
              headerdes.removeClass("top");
              topanchors.removeClass("top"); 
          }
        }
      previousScroll = currentScroll;
    });
}
//had to hardcode values for positioning due to fixed positioning causing issues
if (jQuery(window).width() > 767) {
   jQuery('.top-anchors a').click( function(e){
      event.preventDefault();
      var $target = jQuery(this.hash), target = this.hash;
     console.log($target);
     if(jQuery('.top-anchors').hasClass('fixed')){
       var topstatic = 485;
     }else{
       var topstatic = 820; 
     }
      //var targetOffset = $target.offset().top - topstatic; 
      var targetOffset = $target.offset().top; 
      jQuery('html, body').animate({scrollTop: targetOffset}, 400);
      jQuery('.anchor-group').removeClass('selected');
      jQuery(this).parent().parent().addClass('active');
      jQuery(this).parent().addClass('selected');
      var focusitem =  this.hash;
      jQuery(focusitem).focus();
    });
}
else {
   jQuery('.top-anchors a').click( function(e){
       event.preventDefault();
      var $target = jQuery(this.hash), target = this.hash;
     console.log(target);
     if(jQuery('.top-anchors').hasClass('fixed')){
       var topstatic = 295;
     }else{
       var topstatic = 525; 
     }
      //var targetOffset = $target.offset().top - topstatic; 
      var targetOffset = $target.offset().top;
      jQuery('html, body').animate({scrollTop: targetOffset}, 400);
      jQuery('.anchor-group a').removeClass('selected');
      jQuery(this).parent().parent().addClass('active');
      jQuery(this).addClass('selected');
    });
}

//logic for header scroll persistent fix
var header = jQuery(".custom-header-scroll");
jQuery(window).scroll(function() {
        var scroll = jQuery(window).scrollTop();
        if (scroll >= 128) {
            header.addClass("fix ready animate");
        } else {
           header.removeClass("fix ready animate");
        }
});

// logic scroll for filters on collection page
 //caches a jQuery object containing the header element
if (jQuery('.site-filter-handle-holder-custom').length) {
    var previousScroll = 0;
    var filter = jQuery(".site-filter-handle-holder-custom");
    var filtertopspacing = jQuery(".site-filter-handle-holder-custom").offset().top;
    console.log(filtertopspacing);
    jQuery(window).scroll(function() {
        var scroll = jQuery(window).scrollTop();
        var currentScroll =  jQuery(this).scrollTop();

       if (currentScroll > previousScroll){
         //scrolling down
         if (scroll >= filtertopspacing) {
            filter.addClass("fixed");
            filter.addClass("top");
        } else {
        }
       } else {  
        //scrolling up
        if (scroll >= filtertopspacing) {
            filter.addClass("fixed");
            filter.removeClass("top");
        } else {
            filter.removeClass("fixed");
            filter.removeClass("top");
        }
        }
      previousScroll = currentScroll;
    });
   
}

//opening description on PDP page
$( document ).ready(function() {
if (jQuery('.template-product').length) {
  jQuery(".site-box-content.prod-margin .toggle").eq(0).find("span").trigger("click");
};
});  
//removing link on dark mode logo
if ($('.dark-mode').length) {
  $('.logo-img').attr('href', '#');
}

$(".product__image-zoom").keyup(function(event) {
    if (event.keyCode === 13) {
        console.log('trigger pop-up on enter');
        $(this).click();
    }
});